import axios from 'axios'
import { memberMobx, storeMobx } from '@mobxStore'
import { getEnv } from '@utils'
const { isDebug } = getEnv()

const { BRANDID, token } = Config

// 中断重复请求
const CancelToken = axios.CancelToken
const pending: any[] = []
// 短时间内不可重复访问的接口
const checkApiList = ['listProductByStore_v2']
const removePending = (e: any) => {
  for (let p in pending) {
    let _key = `${e.url}_${e.method}_`
    let _key2 = _key
    try {
      if (e.method === 'get') {
        _key += `${JSON.stringify(e.params || {})}`
      } else {
        _key += `${JSON.stringify(e.data || {})}`
      }
    } catch (error) {
    }
    if (pending[p].u === _key) {
      pending[p].f()
      pending.splice(p as any, 1)
    } else if (pending[p].u2 === _key2 && pending[p].t > 0) {
      const nowTime = new Date().getTime()
      // 500毫秒内不可重复访问
      if (nowTime - pending[p].t < 500) {
        pending[p].f()
        pending.splice(p as any, 1)
      }
    }
  }
}
const setPending = (config) => {
  return new CancelToken((c: any) => {
    let _key = `${config.url}_${config.method}_`
    let _key2 = _key
    let isSomeApi = checkApiList.some(item => config.url.includes(item))
    try {
      if (config.method === 'get') {
        _key += `${JSON.stringify(config.params || {})}`
      } else {
        _key += `${JSON.stringify(config.data || {})}`
        if (config.data instanceof FormData && config.data.get('uuid')) { // 对于请求体是formData的，并且携带uuid的，则认为该请求的key带上uuid。实际场景：上传多张图片
          _key += config.data.get('uuid')
        }
      }
    } catch (error) {
    }
    pending.push({ u: _key, u2: _key2, f: c, t: isSomeApi ? new Date().getTime() : 0 })
  })
}

axios.interceptors.request.use(
  (config) => {
    if (BRANDID) {
      if (config.method === 'post' && config.headers['Content-Type'] !== 'multipart/form-data') {
        const basePostData = {
          brandId: Number(config?.data?.brandId || BRANDID), // 品牌id
          // bo // 业态
        }
        if (config.data) {
          config.data = !Array.isArray(config.data) ? {
            ...basePostData,
            ...config.data,
          } : config.data
          if (Number(config?.data?.brandId || 0) === 0) {
            config.data.brandId = basePostData.brandId
          }
        } else {
          config.data = basePostData
        }
      } else {
        const baseGetParams = {
          brandId: Number(config?.params?.brandId || BRANDID), // 品牌id
          // bo // 业态
        }
        if (config.params) {
          config.params = {
            ...baseGetParams,
            ...config.params,
          }
          if (Number(config?.params?.brandId || 0) === 0) {
            config.params.brandId = baseGetParams.brandId
          }
        } else {
          config.params = baseGetParams
        }
      }
    }
    const bsHeader: any = {}
    const sessionId = sessionStorage.getItem('_bl_sid')
    Config.BRANDID && (bsHeader.brandId = Config.BRANDID)
    Config.STOREID && (bsHeader.storeId = Config.STOREID)
    sessionId && (bsHeader.session_id = sessionId)
    config.url?.includes('/g-activity/') && Config.token && (bsHeader._membertoken = Config.token)
    window.ODMINFO && (bsHeader.odm = window.ODMINFO.key)
    removePending(config)
    config.cancelToken = setPending(config)
    // console.log('bsHeader', bsHeader)
    // console.log('...window.grayMaker()', window.grayMaker())
    // console.log('...window.signMaker()', window.signMaker())
    config?.headers?.token && (bsHeader.token = config.headers.token)
    return {
      ...config,
      headers: {
        dt_timestamp: new Date().getTime(),
        memberToken: Config.token,
        // token: Config.token,
        mobileversion: window.buildinfo.buildDate.substr(2, 8).replace(/-/g, ''),
        i18n: Config.i18n,
        bo,
        ...window.grayMaker(),
        ...(window.signMaker ? window.signMaker() : {}),
        timezone: storeMobx?.info?.timeZone || storeMobx?.brand?.timeZone || '',
        isDebug,
        ...bsHeader,
        'content-type': config.headers['Content-Type'] || 'application/json',
      }
    }
  },
  error => Promise.reject(error),
)

axios.interceptors.response.use(
  (response: any) => {
    removePending(response.config)
    // 微信渠道仅做后台更新，失败不触发全局错误处理或退出登录。
    if (response.config.url?.endsWith('/member/addWechatChannels')) return response.data
    const { error } = response.data
    if (error && error.code) {
      if (error.code === 401) {
        memberMobx.logout(true)
      }
      return Promise.reject({ error: true, message: error.message, code: error.code, data: error.data })
    }
    return response.data
  },
  (error) => {
    if (error.config?.url?.endsWith('/member/addWechatChannels')) return
    return Promise.reject({ error: true, message: error.message })
  },
)

export default axios
